import Homepage from 'components/Homepage/Homepage';
import { withHomepageProps } from 'viewModel/homepage/withHomepageProps';

export default withHomepageProps(Homepage);
